import React, { Component } from 'react';
import { Button, Checkbox, Drawer, Dropdown, Menu, message } from "antd";
// import CKEditor from '@ckeditor/ckeditor5-react';
import CKEditor from 'ckeditor4-react';

// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

// import DecoupledEditor from '@ckeditor/ckeditor5-ownbuild-doc-editor/build/ckeditor';
import parse, { domToReact } from 'html-react-parser';
import { renderToStaticMarkup } from 'react-dom/server';
import { cloneDeep } from 'lodash'
import { CONFIG } from 'config/config';
import { getENVConfig } from '../../util/common'
import EcommerceForm from 'components/EcommerceForm/index'
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

const initialValue = `<p><img alt="/var/folders/lc/c2qslx9548g2mkcnyzj75cbm0000gp/T/com.microsoft.Word/Content.MSO/9FAEBD8D.tmp" src="https://lh5.googleusercontent.com/c3AAb0Tx5S11pDxPe7ifMvSz-gOVPTaF2m-kOPGo7xkz1xWCzL2Ca2SmCJ_bTZRWm-5LZ7f8Wg4MV9TuTf2s68BY3rK8D43Ue1JYN_h7ctog1QiTyl2GFGvdpCj__mkBlbGExtyaaSnZEerdTg" /></p><p>Customer Code: [[customerCode]]</p><p>Shop Name: [[shopName]]</p><p>Address: [[address]]</p><p style="text-align:center"><strong>Scheme Period:&nbsp;</strong>[[periodStart]]<strong>&nbsp;to [[periodEnd]]</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p><table><tbody><tr><td colspan="2"><p style="text-align:center">Turnover Slab (in Rupees) &nbsp; &nbsp;&nbsp;</p></td></tr><tr><td><p style="text-align:center"><strong>Value (Pre-Tax)</strong></p></td><td><p style="text-align:right"><strong>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Incentive &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</strong></p></td></tr><tr><td><strong>Rs.[[turnoverValue]]<strong>&nbsp; &amp; Above in Scheme Period*</strong></td><td><p style="text-align:center">[[incentiveValue]]<strong>%</strong></p></td></tr></tbody></table><p>(*Aforementioned Value of RC products to be purchased in period from 02nd Nov 2019 to 20th Dec 2019)</p><ul><li><strong>There would be an additional 1% ON INVOICE incentive on all purchases during the scheme period with no conditions.&nbsp;</strong></li><li>This offer is valid on purchases of products from Royal Canin India Private Limited [RCIPL] (&ldquo;<strong>Products</strong>&rdquo;) billed to customers by RCIPL between [[periodStart]]&nbsp;to [[periodEnd]]<strong>.</strong> (&ldquo;<strong>Scheme</strong>&rdquo;).</li><li>RCIPL reserves the right to extend this Scheme in select markets only.</li><li>By participating in the Scheme by signing below, each customer unconditionally agrees to abide by these Terms and Conditions and the decision of RCIPL shall be final and binding in all respects.</li><li>Any evidence of clubbing of purchases or misrepresentation of actual purchase by the customer will lead to immediate disqualification from this Scheme without any claims whatsoever.</li><li><strong>The turnover slabs are calculated in Value (Net Sales Value as per NAVISION excluding GST and other taxes) in the scheme period commencing&nbsp;</strong>{periodStart}<strong>&nbsp;to&nbsp;</strong>{periodEnd}</li>
	<li>On successful achieving the Turnover Slab (in value), the appropriate incentive will be calculated on the Net Sales Value (as per Navision excluding GST and other taxes).</li>
	<li>Customers participating in the Scheme are required to clear all outstanding payments against purchases during this program basis the credit terms mentioned on invoice.</li>
	<li>The computation of pay-out would be excluding GST (and other taxes) and only considering Net Sales Value as per NAVISION.</li>
	<li>The Scheme is offered to customers that are registered in NAVISION.</li><li>The pay-out would be reimbursed through credit notes.</li><li>Customers participating in the Scheme are required to clear all outstanding payments against purchases during this program basis the credit terms mentioned on invoice.</li>
	<li>Reimbursement would be done in credit note post clearance of the outstanding payments by the customer.</li>
	<li>All disputes shall be subject to jurisdiction of courts at Mumbai only.</li>
	<li>&nbsp;</li></ul><p>Name of Customer-______________________</p><p>_______________________</p><p>Authorised signatory</p><p>Affix customer stamp</p><p style="text-align:justify">For <strong>ROYAL CANIN INDIA PRIVATE LIMITED</strong></p><p>&nbsp;</p><p>Authorised Signatory</p><p style="text-align:justify">&nbsp;</p><p>&nbsp;</p>`;
CKEditor.editorUrl = 'https://cdn.ckeditor.com/4.13.0/standard-all/ckeditor.js'


class PDFVIew extends Component {
    constructor() {
        super();
        this.state = {
            success: false,
            templateViewData: ""
        }
    }
    componentDidMount() {
        this.setTemplate(this.props)
    }

    componentWillReceiveProps(newProps) {
        this.setTemplate(newProps)
    }

    setTemplate = (propsData) => {
        console.log(propsData, 'childatapropsData')
        if (propsData.screenName === "TransactionList") {
            if (propsData.activeTabIndex === "3" && Object.keys(this.props.formData).length > 0) {
                const options = {
                    replace: ({ attribs, children }) => {
                        if (!attribs) return;
                        children.map((childernData, index) => {
                            console.log(childernData, 'childata')
                            if (childernData.data) {
                                var data = childernData.data;
                                var regex = /\[\[((\w+)]\])/g;
                                var variable = data.match(regex);
                                var label = ''
                                if (variable && variable.length > 0) {
                                    variable.map((vdata, vindex) => {

                                        for (var key in propsData.formData) {
                                            if (propsData.formData.hasOwnProperty(key)) {
                                                let replacedValue = ''
                                                label = vdata.replace(/[^A-Z0-9]/ig, "");
                                                console.log(key.toString(), label, propsData.formData[key], 'vlauesss');
                                                if ((key.toString() === label) && propsData.formData[key]) {
                                                    console.log(data, 'datamm', data.replace(`[[${label}]]`, propsData.formData[key]));
                                                    data = data.replace(`[[${label}]]`, propsData.formData[key]);
                                                    children[index].data = data
                                                    return children
                                                }
                                                if ((key.toString() === label) && propsData.formData[key]) {

                                                }
                                            } else { return }
                                        }
                                    })
                                }
                            } else if (childernData.name === 'input' || childernData.name === 'textarea') {
                                console.log(childernData.attribs, 'findtxta')
                                if (childernData.attribs && childernData.attribs.name) {
                                    for (var key in propsData.formData) {
                                        console.log(key, propsData.formData, propsData.formData.hasOwnProperty(key), 'findtxtk')
                                        if (propsData.formData.hasOwnProperty(key)) {
                                            console.log(childernData.attribs.name, key, propsData.formData[key], (childernData.attribs.name === key) && propsData.formData[key] !== '', 'fdsfsdfdsfdsfdsdsd')
                                            childernData.attribs.name = childernData.attribs.name.replace(/[^A-Z0-9]/ig, "");
                                            if ((childernData.attribs.name === key)) {
                                                if (childernData.attribs.type === 'text') {
                                                    console.log(childernData.attribs.type, propsData.formData[key], 'radiossssssss1')

                                                    if (propsData.formData[key] && propsData.formData[key] !== '') {
                                                        children[index].data = propsData.formData[key];
                                                        children[index].type = 'text'
                                                    } else {
                                                        children[index].type = 'tag'
                                                    }
                                                } else {
                                                    console.log('radiossssssss', propsData.formData[key])
                                                    if (propsData.formData[key]) {
                                                        children[index].attribs.checked = !children[index].attribs.checked
                                                    } else {
                                                        delete children[index].attribs.checked
                                                    }
                                                }
                                                return children
                                            }

                                        }

                                    }
                                }
                            }
                        });
                    }
                }
                this.setState({ templateViewData: `${renderToStaticMarkup(parse(propsData.templateData.displayTemplate, options))}` }, () => {
                })
            } else {
                this.setState({ templateViewData: propsData.templateData.displayTemplate }, () => {
                })
            }

        } else if (propsData.screenName === "TemplateEdit") {
            this.setState({ templateViewData: propsData.templateData.displayTemplate }, () => {
            })
        }
        else {
            this.setState({ templateViewData: initialValue }, () => {
            })
        }
    }


    handleSaveButton(editor) {
    }

    onSave(event) {
        let htmlData = event.editor.getData();
        var html = { data: htmlData }
        this.props.onDisplayChangeProp(htmlData, htmlData)
    }

    handleRequestClose = () => {
        this.setState({ success: false });
    };

    customHandlerBlur = (event) => {
        console.log('customHandlerBlur', event)
        let htmlData = event.editor.getData();
        event.editor.setData(htmlData);
    }

    render() {
        console.log(this.props.templateData, this.state.templateViewData, 'this.state.templateViewData', this.props.from)
        let placeholderConfigValue = {
            placeholderConfig: {
                types: ['customerCode', 'shopName', 'address', 'periodStart', 'periodEnd', 'turnOverValue', 'incentiveValue', 'email', 'phoneNumber']
            }
        };
        return (
            <div className="App" id="app-view" style={{}} >
                {
                    this.state.templateViewData &&
                    <div>

                        {this.props.screenName === "TransactionList" ?
                            <div>
                                <BrowserView>
                                    {this.props.templateData && this.props.templateData.attachmentUrls && this.props.templateData.attachmentUrls.attachedUrl[0] &&
                                        <iframe src={`${this.props.templateData.attachmentUrls.attachedUrl[0]}#toolbar=0`} width='100%' height='1200px'></iframe>
                                    }
                                </BrowserView>
                                <p
                                    className="templetePdf"
                                    dangerouslySetInnerHTML={{ __html: this.state.templateViewData }}
                                />
                            </div> :
                            <div>
                                    <CKEditor
                                        data={this.props.screenName === "newTransaction" ? "" : this.state.templateViewData}
                                        onInit={editor => {
                                            console.log('editor', editor)
                                            editor.editing.view.focus()
                                        }}
                                        onBlur={this.customHandlerBlur.bind(this)}

                                        config={{
                                            removePlugins: 'elementspath',
                                            extraPlugins: 'placeholder,image2,uploadimage,tableresize',
                                            plugins:
                                                'about,' +
                                                'a11yhelp,' +
                                                'basicstyles,' +
                                                'bidi,' +
                                                'blockquote,' +
                                                'clipboard,' +
                                                'colorbutton,' +
                                                'colordialog,' +
                                                'copyformatting,' +
                                                'contextmenu,' +
                                                'dialogadvtab,' +
                                                'div,' +
                                                'elementspath,' +
                                                'enterkey,' +
                                                'entities,' +
                                                'filebrowser,' +
                                                'find,' +
                                                'flash,' +
                                                'floatingspace,' +
                                                'font,' +
                                                'format,' +
                                                'forms,' +
                                                'horizontalrule,' +
                                                'htmlwriter,' +
                                                'iframe,' +
                                                'indentlist,' +
                                                'indentblock,' +
                                                'justify,' +
                                                'language,' +
                                                'link,' +
                                                'list,' +
                                                'liststyle,' +
                                                'magicline,' +
                                                'maximize,' +
                                                'newpage,' +
                                                'pagebreak,' +
                                                'pastefromgdocs,' +
                                                'pastefromword,' +
                                                'pastetext,' +
                                                'preview,' +
                                                'print,' +
                                                'removeformat,' +
                                                'resize,' +
                                                'save,' +
                                                'selectall,' +
                                                'showblocks,' +
                                                'showborders,' +
                                                'smiley,' +
                                                'sourcearea,' +
                                                'specialchar,' +
                                                'stylescombo,' +
                                                'tab,' +
                                                'table,' +
                                                'tableselection,' +
                                                'tabletools,' +
                                                'templates,' +
                                                'toolbar,' +
                                                'undo,' +
                                                'uploadimage,' +
                                                'wysiwygarea',
                                            toolbar: [
                                                { name: 'document', items: ['Source', '-', 'Save', 'Preview', 'Print', '-', 'Templates'] },
                                                { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                                                { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll'] },
                                                { name: 'forms', items: ['Form', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
                                                // { name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
                                                '/',
                                                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
                                                { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
                                                { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                                                { name: 'insert', items: ['CreatePlaceholder', 'Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
                                                '/',
                                                { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                                                { name: 'colors', items: ['TextColor', 'BGColor'] },
                                                { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
                                                { name: 'about', items: ['About', 'ckfinder'] }
                                            ],
                                            height: 'calc(100vh - 48vh)',
                                            // Upload imges to a CKFinder connector (note that the response type is set to JSON).
                                            uploadUrl: `${getENVConfig(CONFIG.CLOUDFUNCTIONS)}/uploadImage`,
                                            filebrowserUploadUrl: `${getENVConfig(CONFIG.CLOUDFUNCTIONS)}/uploadImage`,
                                            filebrowserImageUploadUrl: `${getENVConfig(CONFIG.CLOUDFUNCTIONS)}/uploadImage`
                                        }}
                                        onChange={this.onSave.bind(this)}

                                    //  readOnly={false}
                                    />
                            </div>

                        }
                    </div>
                }
               

            </div>
        );
    }
}

export default PDFVIew;